import agent from '../../agent';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { APP_LOAD, REDIRECT, NOTIFICATION } from '../../constants/actionTypes';
import './App.css'
import io from 'socket.io-client';
import {Toaster,emitToastForNotification} from '../Dashboard/components/Toaster/Toaster'

const mapStateToProps = state => ({
  appLoaded: state.common.appLoaded,
  appName: state.common.appName,
  redirectTo: state.common.redirectTo
});

const mapDispatchToProps = dispatch => ({
  onLoad: (token, configurationId) =>
    dispatch({ type: APP_LOAD, token, configurationId}),
  onNotification: (notification) =>
    dispatch({type:NOTIFICATION, notification}),
  onRedirect: () =>
    dispatch({ type: REDIRECT })
});

const socket = io(process.env.REACT_APP_NOTIFICATION_SERVER_URL);

class App extends React.Component {

  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      this.context.router.replace(nextProps.redirectTo);
      this.props.onRedirect();
    }
  }

  componentWillMount() {
    var token = window.localStorage.getItem('jwt');
    if (token && token !== '') {
      agent.setToken(token);
    }

    const configurationId = window.localStorage.getItem('configurationId');

    if(!configurationId || configurationId === '') {
      window.localStorage.setItem('jwt','');
      token = ''
    }

    this.props.onLoad(token, configurationId);
  }

  componentDidMount() {
    socket.on('notification', this.handleNotification.bind(this))
  }

  handleNotification(notification) {
    this.props.onNotification(notification);
    emitToastForNotification(notification);
  }

  render() {
    if (this.props.appLoaded) {
      return (
        <div>
          {this.props.children}
          <Toaster/>
        </div>
      );
    }
    return (
      <div>

      </div>
    );
  }
}

App.contextTypes = {
  router: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js